
import { useEffect } from 'react';
import AboutNavbar from './components/AboutNavbar';
import AboutHero from './components/AboutHero';
import OurStory from './components/OurStory';
import Values from './components/Values';
import Metrics from './components/Metrics';
import Team from './components/Team';
import AboutCTA from './components/AboutCTA';
import Footer from '../home/components/Footer';

export default function About() {
  // Scroll to top when the component mounts
  useEffect(() => {
    try {
      window.scrollTo(0, 0);
    } catch (error) {
      // In environments where `window` is not defined (e.g., SSR),
      // we safely ignore the scrolling action.
      console.warn('Scrolling to top failed:', error);
    }
  }, []);

  return (
    <div className="min-h-screen">
      <AboutNavbar />
      <AboutHero />
      <OurStory />
      <Values />
      <Metrics />
      <Team />
      <AboutCTA />
      <Footer />
    </div>
  );
}
